const cards = [
  {
    title: '2024年度十大必看国产剧',
    tag: '年度盘点',
    desc: '从古装权谋到现代都市，盘点今年口碑与热度双丰收的国产佳作，每一部都值得二刷。',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20period%20drama%20collection%20collage%20with%20elegant%20costumes%20and%20traditional%20settings%2C%20warm%20golden%20tones%2C%20cinematic%20composition%2C%20editorial%20photography%20style&width=800&height=560&seq=bbtv-card-01&orientation=landscape',
    date: '7月28日',
  },
  {
    title: '暑期档电影推荐：这10部不容错过',
    tag: '影单推荐',
    desc: '炎炎夏日窝在家吹空调看好片，从国产巨制到海外佳作，暑期档观影指南来了。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20night%20vibe%20with%20popcorn%20and%20film%20reel%2C%20cozy%20dark%20room%20with%20warm%20ambient%20glow%2C%20home%20cinema%20aesthetic%2C%20lifestyle%20photography&width=800&height=560&seq=bbtv-card-02&orientation=landscape',
    date: '7月27日',
  },
  {
    title: '悬疑剧爱好者必看：烧脑神作合集',
    tag: '悬疑专场',
    desc: '反转再反转，结局绝对猜不到。精选国内外高口碑悬疑剧集，准备好脑细胞开始推理。',
    img: 'https://readdy.ai/api/search-image?query=Mysterious%20noir%20atmosphere%20with%20shadowy%20alley%20and%20detective%20elements%2C%20moody%20dark%20lighting%2C%20film%20noir%20aesthetic%2C%20suspenseful%20cinematic%20composition&width=800&height=560&seq=bbtv-card-03&orientation=landscape',
    date: '7月26日',
  },
  {
    title: '韩剧迷的快乐源泉：高分韩剧全收录',
    tag: '韩剧专区',
    desc: '从浪漫爱情到社会现实，口碑炸裂的韩剧都在这里。附带冷门佳作推荐，入股不亏。',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20romantic%20scene%20with%20cherry%20blossoms%20and%20warm%20spring%20lighting%2C%20soft%20pastel%20tones%2C%20emotional%20cinematic%20moment%2C%20k-drama%20aesthetic&width=800&height=560&seq=bbtv-card-04&orientation=landscape',
    date: '7月25日',
  },
  {
    title: '周末放松：轻松搞笑喜剧片单',
    tag: '喜剧精选',
    desc: '工作压力大？来部喜剧解解压。精选国内外爆笑佳作，保证让你笑到停不下来。',
    img: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20comedy%20scene%20with%20colorful%20confetti%20and%20laughter%2C%20warm%20vibrant%20lighting%2C%20fun%20playful%20atmosphere%2C%20lighthearted%20cinematic%20style&width=800&height=560&seq=bbtv-card-05&orientation=landscape',
    date: '7月24日',
  },
  {
    title: '经典港片重启：那些年的港味回忆',
    tag: '港片经典',
    desc: '重温香港电影黄金年代的经典作品，周星驰、成龙、王家卫，每一帧都是回忆杀。',
    img: 'https://readdy.ai/api/search-image?query=Hong%20Kong%20nostalgic%20street%20scene%20with%20neon%20signs%20and%20vintage%20vibe%2C%20warm%20retro%20lighting%2C%20classic%20HK%20cinema%20aesthetic%2C%20atmospheric%20film%20photography&width=800&height=560&seq=bbtv-card-06&orientation=landscape',
    date: '7月23日',
  },
  {
    title: '动漫爱好者的天堂：热门新番速递',
    tag: '动漫频道',
    desc: '国漫崛起与日漫经典齐飞，最新番剧同步更新，二次元的小伙伴们快来集合。',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20illustration%20with%20colorful%20characters%20and%20dynamic%20composition%2C%20energetic%20action%20pose%2C%20bright%20vibrant%20colors%2C%20modern%20anime%20aesthetic&width=800&height=560&seq=bbtv-card-07&orientation=landscape',
    date: '7月22日',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            精选内容
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-extrabold text-foreground-900">
            为你精选的观影指南
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            编辑团队精心整理的片单与专题，帮你发现更多好内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {cards.map((card, idx) => (
            <article
              key={idx}
              className={`group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                idx === 0 ? 'sm:col-span-2 lg:col-span-2 xl:col-span-2' : ''
              }`}
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-background-100">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading font-bold text-sm md:text-base text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className={`text-xs md:text-sm text-foreground-500 leading-relaxed mb-3 ${idx === 0 ? '' : 'line-clamp-2'}`}>
                  {card.desc}
                </p>
                <span className="text-xs text-foreground-400">{card.date}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}